import { Button, Dialog } from '../ui';

export interface UnlinkDialogProps {
  open: boolean;
  providerName: string;
  busy: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/** Confirmation modal for unlinking a provider (spec §7.7). */
export function UnlinkDialog({ open, providerName, busy, onConfirm, onCancel }: UnlinkDialogProps) {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      title={`Gỡ liên kết ${providerName}?`}
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={busy}>
            Hủy
          </Button>
          <Button variant="danger" onClick={onConfirm} loading={busy} disabled={busy}>
            Gỡ liên kết
          </Button>
        </>
      }
    >
      <p className="muted">
        Bạn sẽ không thể dùng {providerName} để đăng nhập vào tài khoản này nữa.
      </p>
    </Dialog>
  );
}
